<div class="modal-header px-4">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>

<div class="modal-body my-2">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Parent or expandable node -->
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
    >
      <button mat-icon-button matTreeNodeToggle>
        <mat-icon>{{
          treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
        }}</mat-icon>
      </button>
      <mat-checkbox disabled>
        {{ node.item }}
      </mat-checkbox>
    </mat-tree-node>

    <!-- Leaf node -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button disabled></button>
      <mat-checkbox
        color="accent"
        [checked]="checklistSelection.isSelected(node)"
        (change)="toggleSelection(node)"
      >
        {{ node.item }}
      </mat-checkbox>
    </mat-tree-node>
  </mat-tree>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button class="btn-accello-primary-light" [disabled]="!this.checklistSelection.selected.length" (click)="submit()">
      {{ configs?.saveBtnText ? configs.saveBtnText : "Select & Generate" }}
    </button>
  </div>
</div>
